class GetExchangeRateService {
  constructor(httpService) {
    this.http = httpService;
  }
  async execute(clientId, client) {
    return this.http.get(`/tipoCambio`)
  }
}

export default GetExchangeRateService